import Is from "./Is";

export default class Semantic {

    static $numeric(arg: any)
    {
        const validations = [
            Is.$number,
            (arg: any) => {
                let $arg = String(arg || '');
                let regex = /^[-+]?(([0-9]+)|([0-9]*(\.[0-9]+))|([0-9]+\.))([Ee]([-+]?[0-9]+))?$/g;

                return regex.test( $arg );
            }
        ];

        return validations.some(validation => validation(arg));
    }

    static $primitive(arg: any)
    {
        let validations = [
            Is.$undefined,
            Is.$null,
            Is.$boolean,
            Is.$number,
            Is.$string,
            (arg: any) => Is.is(arg, 'Symbol')
        ]

        return validations.some(validation => validation(arg))
    }

    static $empty(arg: any)
    {
        let validations = [
            Is.$undefined,
            Is.$null,

            (arg: any) => Is.$boolean(arg) && !arg,
            (arg: any) => Is.$number(arg) && arg === 0,
            (arg: any) => (Is.$array(arg) || Is.$string(arg)) && (arg === "0" || (arg as any[]|string).length === 0)
        ]

        return validations.some(validation => validation(arg))
    }

}